import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { CurrencySelect } from '@/components/currency-select';

interface ChargeCurrencySelectProps {
  currencies: string[];
}

/**
 * Charge currency select component
 * The currency used to charge customers' payment methods
 */
export const ChargeCurrencySelect = ({ currencies }: ChargeCurrencySelectProps) => {
  const { t } = useTranslation(['stores', 'common']);
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<{ chargeCurrency: string; baseCurrency: string }>();

  // When charge currency changes, also update reporting currency (base currency)
  const handleChargeCurrencyChange = (value: string) => {
    setValue('chargeCurrency', value);
    // Auto-set reporting currency to match charge currency
    setValue('baseCurrency', value);
  };

  return (
    <div id="store-charge-currency-select" className="space-y-2">
      <div className="flex items-center gap-1">
        <Label>{t('form.chargeCurrency')}</Label>
        <span className="text-red-500">*</span>
      </div>
      <p className="text-xs text-gray-500">
        {t('form.chargeCurrencyDescription')}
      </p>
      <Controller
        name="chargeCurrency"
        control={control}
        render={({ field: { value } }) => (
          <CurrencySelect
            currencies={currencies}
            value={value || ''}
            onChange={handleChargeCurrencyChange}
            placeholder={t('form.selectCurrency')}
          />
        )}
      />
      {errors.chargeCurrency && (
        <p className="text-sm text-red-500">{(errors.chargeCurrency as any).message as string}</p>
      )}
    </div>
  );
};
